<template>
    <div id="app" data-app>
        <Analytics v-if="user && user.username !== 'kypaku@mail.ru'"/>
        <v-app>     
            <Header />
            <RelatedWindow :element="relevant_element" :addElementsInTask="!relevant_element.microTasks" v-if="relevant_element" @toCloseRelWindow="SET_RELEVANT_ELEMENT(null)"/>
            <!-- <Settings/> -->
            <!-- {{$t("test")}}  -->
            <keep-alive><router-view/></keep-alive>      
            <Popups />
            <Messages />      
        </v-app>
    </div>
</template>

<script>
    import Header from './components/header/Header.vue';
    // import Settings from './components/misc/Settings'
    import Popups from './components/popups/Popups'
    import Messages from './components/misc/Messages'
    import { mapGetters, mapMutations } from 'vuex'
    import Analytics from './components/misc/Analytics.vue'
    import RelatedWindow from './components/main/RelatedElements/RelatedWindow'

    export default {
        name: 'app',
        components: {
            Analytics,
            // Settings,
            Header,
            Popups,
            Messages,
            RelatedWindow
        },
        metaInfo: {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: 'Удобное приложение для заметок',
            meta: [
                {
                    ame: 'viewport',
                    content: 'width=device-width, initial-scale=1',
                },
                {
                    name: 'apple-mobile-web-app-title',
                    content: 'Tasko',
                },
                {
                    name: 'og:site_name',
                    content: 'Tasko',
                },
                {
                    name: 'og:type',
                    content: 'website',
                },
                {
                    name: 'og:image',
                    content: 'https://app.tasko.xyz/img/logo.243ec6aa.svg',
                },
                {
                    name: 'og:image:secure_url',
                    content: 'https://app.tasko.xyz/img/logo.243ec6aa.svg',
                },
                {
                    name: 'og:image:alt',
                    content: 'Tasko',
                },
                {
                    name: 'description',
                    content: 'Приложение для создания и управления заметками, позволяет структурировать, связывать и добавлять вложения в записи',
                },
                {
                    name: 'og:description',
                    content: 'Приложение для создания и управления заметками, позволяет структурировать, связывать и добавлять вложения в записи',
                },
                {
                    name: 'title',
                    content: 'Tasko - Удобное приложение для заметок',
                },
                {
                    name: 'og:title',
                    content: 'Tasko - Удобное приложение для заметок',
                },
                {
                    name: 'og:url',
                    content: 'https://tasko.xyz',
                },
            ],
            link: [
                { rel: "canonical", href: 'https://tasko.xyz' },
            ],
            // all titles will be injected into this template
            titleTemplate: 'Tasko - %s'
        },
        computed:{
            ...mapGetters(['relevant_element', 'user'])
        },
        methods: {
            ...mapMutations(['SET_RELEVANT_ELEMENT'])
        }
    }
  
</script>

<style lang="scss">
    @import "assets/styles/main.scss";
    @import url('https://fonts.googleapis.com/css2?family=Questrial&display=swap');
    :root{
        --cl-bg: white;
        --cl-bg2: #f7f7f7;
        // --cl-primary: #18A0FB;
        // --cl-secondary: #EEF8FF;
        --cl-primary:#4DBA87;
        --cl-secondary: #dcfdf0;
        --head-h: 48px;
        --clr-blue: #18A0FB;
        --clr-green: #16F78B;
    }
    .left{
        float: left;
    }
    .right{
        float: right;
    }
    .transition-max-width-600ms{
        transition: max-width 600ms;
    }
    .underline{
        text-decoration: underline;
    }
    .v-picker__title.primary{
        background: #b9f3a6;
    }
    .v-time-picker-clock__hand{
        background: #b9f3a6;
    }
    .flex-center{
        display: flex;
        align-items: center;
    }
    .flex-center-between{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .relative{
        position: relative;
    }
    .absolute{
        position: absolute;
    }
    .fixed{
        position: fixed;
    }
    .pointer{
        cursor: pointer;
    }
    .v-dialog{
        margin: 0 !important;
    }
    .w-100{
        width: 100%;
    }
    .text-center{
        text-align: center;
    }
    .text-left{
        text-align: left;
    }
    .text-right{
        text-align: right;
    }
    .icon-primary{
        color: var(--cl-primary) !important;
        opacity: 1 !important;          
    }
    .placeholder{
        color: #333;
        font-size: 14px;
    }
</style>
